import axios from 'axios'
import CacheService from './cacheService'
import {
  getRequestConfig,
  getCanadaPostConfig,
  webRequest,
} from '../utils/requests'
const cacheService = CacheService.getInstance()
const AXIOS = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
})

const axiosWrapper = (fn, useCache, ...args) => {
  const remoteCaller = (resolve, reject) => {
    fn(...args)
      .then(res => {
        const { data } = res
        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
  }

  const promise = new Promise((resolve, reject) => {
    if (useCache) {
      const result = cacheService.get(args[0])
      if (result) {
        resolve(result)
      } else {
        remoteCaller(resolve, reject)
      }
    } else {
      remoteCaller(resolve, reject)
    }
  })
  return promise
}

export const mediatorService = {
  getSessionId: () =>
    axiosWrapper(
      AXIOS.get,
      false,
      webRequest(getRequestConfig('getSessionId'))
    ),
}
export const productService = {
  getSkus: (skus, locale) =>
    axiosWrapper(
      AXIOS.get,
      false,
      `${webRequest(getRequestConfig('getSkus'))}${skus}?locale=${locale}`
    ),
  getProgramType: (sku, locale) =>
    axiosWrapper(
      AXIOS.get,
      false,
      `${webRequest(getRequestConfig('programTypeProvider'))}${sku}?locale=${locale}`
    ),
}
export const checkoutService = {
  createSignature: (data, locale) =>
    axiosWrapper(
      AXIOS.post,
      false,
      `${webRequest(getRequestConfig('createSignature'))}?locale=${locale}`,
      JSON.stringify(data)
    ),
  calculateTaxes: data =>
    axiosWrapper(
      AXIOS.post,
      false,
      `${webRequest(getRequestConfig('calculateTaxes'))}`,
      JSON.stringify(data)
    ),
  confirmPayment: data =>
    axiosWrapper(
      AXIOS.post,
      false,
      `${webRequest(getRequestConfig('confirmPayment'))}`,
      JSON.stringify(data)
    ),
  processPayment: data =>
    axiosWrapper(
      AXIOS.post,
      false,
      `${webRequest(getRequestConfig('processPayment'))}`,
      data,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
      }
    ),
}
export const canadaPostService = {
  addressComplete: (SearchTerm, locale) =>
    axiosWrapper(
      AXIOS.get,
      false,
      `${webRequest(getCanadaPostConfig().addressComplete)}&SearchTerm=${SearchTerm}&LanguagePreference=${locale}`
    ),
  retrieveAddress: id =>
    axiosWrapper(
      AXIOS.get,
      false,
      `${webRequest(getCanadaPostConfig().retrieveAddress)}&Id=${id}`
    ),
}



// WEBPACK FOOTER //
// ./src/services/apiService.js